import { ActionTree } from "vuex";
import {
  CompanyState,
  AddUBOPayload,
  CompanyDocumentUploadPayload,
  UpdateCompanyPayload,
  UBO,
} from "../types";
import API from "@/axios";
import { base64toBlob } from "@/utils/index";

const actions: ActionTree<CompanyState, any> = {
  addToUBOList({ commit }, payload: UBO) {
    commit("addUBO", payload);
  },
  removeUBO({ commit }, index: number) {
    commit("removeUBO", index);
  },
  createUBOs({ commit }, payload: AddUBOPayload) {
    return API.post(`/companies/${payload.companyId}/create_applicants`, {
      publicKey: payload.publicKey,
      data: payload.data,
    });
  },
  async updateCompanyInfo({ dispatch }, payload: UpdateCompanyPayload) {
    //upload documents
    for await (const file of payload.documents) {
      await dispatch("uploadDocument", {
        files: file,
        companyId: payload.companyId,
      });
    }

    //update company info
    return API.post(`/companies/${payload.companyId}/update_info`, {
      name: payload.name,
      registrationNumber: payload.registrationNumber,
      countryCode: payload.countryCode,
      publicKey: payload.publicKey,
    });
  },
  async uploadDocument({ commit }, payload: CompanyDocumentUploadPayload) {
    return API.post(
      `/companies/${payload.companyId}/documents`,
      payload.files,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
};

export default actions;
